import React, { memo } from 'react';
import PropTypes from 'prop-types';
import setClass from '../../common/set-class';
import Loader from '../loader';
import NoContent from './no-content';
import TableHeader from './table-header';
import TableRow from './table-row';
const Table = ({ isLoading, sort, setSort, data, columns, ExpandedComponent, getIsRowExpandable, className, style, noDataMessage, }) => (React.createElement("div", { className: setClass('b-table', 'b-txt', className), style: style },
    isLoading && React.createElement(Loader, { cover: true }),
    React.createElement(TableHeader, { columns: columns, sort: sort, setSort: setSort, withExpandColumn: !!ExpandedComponent }),
    React.createElement("ul", { className: "b-table__body" }, data?.map((item, index) => (React.createElement(TableRow, { key: item.id || `-i-${index}`, index: index, item: item, columns: columns, ExpandedComponent: ExpandedComponent, getIsRowExpandable: getIsRowExpandable })))),
    data?.length === 0 && noDataMessage));
Table.propTypes = {
    isLoading: PropTypes.bool,
    sort: PropTypes.string,
    setSort: PropTypes.func,
    data: PropTypes.array,
    columns: PropTypes.arrayOf(PropTypes.shape({
        isSortable: PropTypes.bool,
        className: PropTypes.string,
        fieldName: PropTypes.string.isRequired,
        header: PropTypes.string,
        ratio: PropTypes.number,
        HeaderCell: PropTypes.elementType,
        Cell: PropTypes.elementType,
    })).isRequired,
    ExpandedComponent: PropTypes.func,
    getIsRowExpandable: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
    noDataMessage: PropTypes.node,
};
Table.defaultProps = {
    isLoading: false,
    sort: undefined,
    setSort: () => { },
    data: undefined,
    ExpandedComponent: undefined,
    getIsRowExpandable: () => true,
    className: undefined,
    style: undefined,
    noDataMessage: React.createElement(NoContent, { className: "b-table__no-content" }),
};
export default memo(Table);
